import React, { useState, useEffect, useMemo } from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AccordionItem from '../../../components/AccordionItem';
import { htmlDecode } from '../../../utilities/helpers';
import { useSetting } from '../../../utilities/sharedHooks/settings';

const FAQ = () => {
  const { t: translate, i18n: transalationOptions } = useTranslation();
  const history = useHistory();

  const currentLang = transalationOptions?.language || 'en';

  const [yieldFaqList] = useSetting('convexity_yield', 'convexity_yield_faq');

  const questions = useMemo(() => {
    if (yieldFaqList) {
      const faqList = JSON.parse(yieldFaqList);

      const preparedFaqList = faqList.map((item, index) => {
        const header = htmlDecode(item?.question[currentLang]);
        const content = htmlDecode(item?.answer[currentLang]);
        return { order: index, header, content };
      });

      return preparedFaqList;
    }
    return [];
  }, [yieldFaqList, currentLang]);

  const [questionsState, updateQuestionsState] = useState({});

  useEffect(() => {
    if (questions) {
      const states = {};
      questions.forEach((question) => {
        states[`question_${question?.order}`] = false;
      });
      updateQuestionsState(states);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeQuestionsState = (questionOrder) => {
    const newStates = {};
    questions
      .filter((question) => question.order !== questionOrder)
      .forEach((question) => {
        newStates[`question_${question?.order}`] = false;
      });
    newStates[`question_${questionOrder}`] = !questionsState[`question_${questionOrder}`];
    updateQuestionsState(newStates);
  };

  const renderHeader = () => (
    <div className="d-flex">
      <div
        className={`d-flex flex-row w-100 align-items-center mb-4 ${
          isMobile ? 'justify-content-start' : 'justify-content-between'
        }`}>
        <div className={`row ${isMobile ? 'mx-0 px-0' : 'ps-2'} w-100`}>
          <div className={`col-md-3 ${!isMobile && 'ps-0'}`}>
            <div
              className={`d-flex flex-row cursor-pointer text-hover ${
                isMobile ? 'd-flex flex-grow-1' : ''
              }`}
              onClick={() => history.push('/dashboard/oxygen_yield')}
              onKeyDown={() => history.push('/dashboard/oxygen_yield')}
              role="presentation"
              tabIndex="-1">
              <i className="icon icon-arrow-back-navigation text-f4 me-2" aria-label="Back" />
              <b
                className={`text-f5 me-auto d-block ${
                  isMobile ? 'd-flex flex-grow-1 align-items-center' : ''
                }`}>
                {translate('yield_FAQ_screen_title')}
              </b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container mt-5 p-0 w-100">
      {renderHeader()}
      <p className={`text-dark text-f4 text-bold ${isMobile ? 'px-3' : ''}`}>
        {translate('yield_FAQ_main_label')}
      </p>
      <div className="row mt-4">
        <div className="col-md-10 col-12">
          <div
            className={`overflow-auto ${isBrowser ? 'h-65vh mt-1 pe-3' : 'h-auto px-3'}`}
            style={{
              width: isBrowser ? `calc(100% + 1rem)` : '100%',
              marginBottom: isBrowser ? '' : '2rem',
            }}>
            {questions &&
              questions.map((question) => (
                <AccordionItem
                  className="bg-lighter mb-3"
                  key={question?.header}
                  header={question?.header}
                  content={question?.content}
                  opened={questionsState[`question_${question.order}`]}
                  onClick={() => changeQuestionsState(question?.order)}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
